import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";
import { Modal } from "react-bootstrap";
import { Table, TableCell, TableHead, TableRow, TableBody, Typography } from "@material-ui/core";
const moment = require("moment");

const ListJadwalAndProfileCbt = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [listJadwalAndProfil, setListJadwalAndProfil] = useState([]);

  useEffect(() => {
    if (isOpen) {
      fetchListJadwalAndProfil();
    }
  }, [isOpen]);

  const formatDate = (s) => {
    return moment(s).format("DD MMM YYYY HH:mm");
  };

  const fetchListJadwalAndProfil = async () => {
    setListJadwalAndProfil([]);
    await akmApi
      .get(URL_AKM.FETCH_JADWAL_AND_PROFIL_BY_PAKET_PROGRAM + props.paketProgram.idPaketProgram)
      .then((response) => {
        console.log(response.data.errorSchema);
        if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          setListJadwalAndProfil(response.data.data);
        } else {
          setListJadwalAndProfil([]);
          console.log(response.data.errorSchema.errorMessage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Fragment>
      <button className="btn btn-outline-secondary btn-sm" onClick={() => setIsOpen(!isOpen)}>
        <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
      </button>

      <Modal show={isOpen} onHide={() => setIsOpen(!isOpen)} aria-labelledby="example-custom-modal-styling-title" size="xl" backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Typography variant="h6" component="h6" style={{ fontWeight: "bold" }}>
            {props.paketProgram.namaProgram}
          </Typography>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="body1">List Jadwal dan Profil</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell>Nama Profil</TableCell>
                <TableCell>Nama Jadwal</TableCell>
                <TableCell>Scope</TableCell>
                <TableCell>Mulai</TableCell>
                <TableCell>Selesai</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!__.isEmpty(listJadwalAndProfil) &&
                listJadwalAndProfil.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{data.namaProfilCbt}</TableCell>
                    <TableCell>{data.namaJadwal}</TableCell>
                    <TableCell>{data.scope}</TableCell>
                    <TableCell>{formatDate(data.startDate)}</TableCell>
                    <TableCell>{formatDate(data.expiredDate)}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default ListJadwalAndProfileCbt;
